module.exports = __webpack_public_path__ + "img/related-questions.1950d7cd.svg";